import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"background-color":"#f5f5f9","height":"100vh"},attrs:{"fluid":""}},[_c('SidebarCompVue'),_c('main',{staticClass:"main-wrapper"},[_c('HeaderComp'),_vm._t("default")],2),_c('footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }